import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from '@/environments/environment';
import { NewAiSolutionUsageRequest, NewAiSolutionUsageResponse } from '@/app/interfaces/new-ai-solution-usage';
import { ToastService } from '../script/toast.service';
import { LoaderService } from '@/app/services/interceptor/loader-service';
import { PermitSynchronizeService } from './permit-synchronize.service';

@Injectable({
  providedIn: 'root',
})
export class NewAiSolutionUsageService {
  constructor(
    private toastService: ToastService,
    private loader: LoaderService,
    private permitSynchronizeService: PermitSynchronizeService
  ) {}

  async createNewAiSolutionUsage(payload: NewAiSolutionUsageRequest): Promise<NewAiSolutionUsageResponse> {
    try {
      this.loader.show();
      const response = await axios.post<NewAiSolutionUsageResponse>(
        `${environment.url}/api/aurora/validar_y_guardar_solucion_IA`,
        payload,
        {
          withCredentials: true,
        }
      );

      this.permitSynchronizeService.synchronizeSolutionPermissions(payload.requestingOrg);
      this.toastService.showSuccess('Uso de solucion IA creado', 'El uso de solucion IA se ha creado correctamente');
      return response.data;
    } catch (error) {
      this.toastService.showError(
        'Error al crear uso de solucion IA.',
        error?.response?.data?.message || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      this.loader.hide();
    }
  }
}
